export default __webpack_public_path__ + "static/media/single-family.c0e44512.png";